var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('HomepageDashboard'),_c('section',{staticClass:"homepage-content"},[_c('div',{staticClass:"container"},[_c('HomepageTutorial'),_c('HomepageFAQ')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }